export default "__VITE_ASSET__B6XW2pp$__"